import React, { useEffect, useState } from 'react';
import { supabase } from '../utils/supabaseClient';

const LoadingSpinner: React.FC = () => {
    const [showReset, setShowReset] = useState(false);

    useEffect(() => {
        // If loading takes more than 5 seconds, show reset button
        const timer = setTimeout(() => {
            setShowReset(true);
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    const handleForceLogout = async () => {
        await supabase.auth.signOut();
        window.location.href = '/login';
    };

    return (
        <div className="flex flex-col items-center justify-center p-8 w-full h-full min-h-[50vh]">
            <div className="flex flex-col items-center gap-3">
                <span className="material-symbols-outlined text-4xl text-primary animate-spin">
                    progress_activity
                </span>
                <p className="text-gray-500 text-sm font-medium animate-pulse">Carregando...</p>

                {showReset && (
                    <div className="mt-8 flex flex-col items-center gap-2 animate-fade-in">
                        <p className="text-xs text-red-500">Demorando muito?</p>
                        <button
                            onClick={handleForceLogout}
                            className="px-4 py-2 bg-white border border-red-200 text-red-600 rounded-lg text-sm hover:bg-red-50 transition-colors shadow-sm"
                        >
                            Sair e Tentar Novamente
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoadingSpinner;
